/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MarketplaceWebhookSubscription } from './MarketplaceWebhookSubscription';
/**
 * Web hook Payload get or set the API Response Data.
 */
export type MarketplaceWebhookPayload = {
    /**
     * Gets or sets the action.
     */
    action?: MarketplaceWebhookPayload.action;
    /**
     * Gets or sets the activity identifier.
     */
    activityId?: string;
    /**
     * Gets or sets the offer identifier.
     */
    offerId?: string | null;
    /**
     * Gets or sets the operation identifier.
     */
    Id?: string;
    /**
     * Gets or sets the plan identifier.
     */
    planId?: string | null;
    /**
     * Gets or sets the publisher identifier.
     */
    publisherId?: string | null;
    /**
     * Gets or sets the quantity.
     */
    quantity?: number | null;
    /**
     * Gets or sets the status.
     */
    status?: MarketplaceWebhookPayload.status;
    /**
     * Gets or sets the subscription identifier.
     */
    subscriptionId?: string;
    /**
     * Gets or sets the time stamp.
     */
    timeStamp?: string;
    /**
     * Gets or sets the Subscription information.
     */
    subscription?: MarketplaceWebhookSubscription | null;
};
export namespace MarketplaceWebhookPayload {
    /**
     * Gets or sets the action.
     */
    export enum action {
        UNSUBSCRIBE = 'Unsubscribe',
        CHANGE_PLAN = 'ChangePlan',
        CHANGE_QUANTITY = 'ChangeQuantity',
        SUSPEND = 'Suspend',
        REINSTATE = 'Reinstate',
        RENEW = 'Renew',
        TRANSFER = 'Transfer',
    }
    /**
     * Gets or sets the status.
     */
    export enum status {
        NOT_STARTED = 'NotStarted',
        IN_PROGRESS = 'InProgress',
        FAILED = 'Failed',
        SUCCEEDED = 'Succeeded',
        CONFLICT = 'Conflict',
    }
}

